export enum EAmountType {
  Percent = 'percent',
  Flat = 'flat',
}
